import { AdminDashboard } from '@/components/admin-dashboard'

export default function AdminHomePage() {
  return <AdminDashboard />
}